/*
 * 中小型终端
 */
import React from 'react';
import cn from 'classnames';
import Scheme from 'components/product/scheme';
import Contact from 'components/contact';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import Medias from 'components/medias';
import style from './index.module.scss';

const IMG_PRE = 'https://sdk-source.xylink.com/website/assets/hardware/hard/GE300/';

const features = [{ name: '主机' }, { name: '摄像机' }, { name: '麦克风' }, { name: 'Wi-Fi' }, { name: '蓝牙' }];

const AI = [
  {
    title: '摄像头支持人脸检测，智能判断参会人数与位置',
    pcUrl: IMG_PRE + 'AI-img0.jpg',
  },
  {
    title: '无需手动调整，摄像头可动态选取理想画面',
    pcUrl: IMG_PRE + 'AI-img1.jpg',
  },
];
const bannerList = [
  {
    title: '丰富接口，高效扩展',
    pcUrl: 'bg3.jpg',
    mUrl: 'm/bg3.jpg',
    desc: '提供丰富的音视频接口，满足会议室集成需求\n高效扩展各类办公协作场景',
    type: 3,
    className: style.banner1,
  },
  {
    title: '专属遥控器，操作简便',
    pcUrl: 'bg4.jpg',
    mUrl: 'm/bg4.jpg',
    desc: '标配智能双模遥控器，蓝牙红外双模式智能切换\n专属功能按键一目了然，会议操作更便捷',
    mDesc: '标配智能双模遥控器，蓝牙红外双模式智能切换\n专属功能按键一目了然，会议操作更便捷',
    type: 4,
  },
  {
    title: '全网环境适应，稳定保障',
    pcUrl: 'bg5.jpg',
    mUrl: 'm/bg5.jpg',
    desc: 'H.264、H.265柔性编解码算法，前向纠错、丢包重传、丢包保护\n超强网络适应性，有效保障会议稳定流畅',
    mDesc: 'H.264、H.265柔性编解码算法，前向纠错、丢\n包重传、丢包保护\n超强网络适应性，有效保障会议稳定流畅',
    type: 3,
    className: style.banner2,
  },
];
const scene = [
  {
    title: '中小型会议室商务洽谈',
    pcUrl: IMG_PRE + 'scene-img0.jpg',
  },
  {
    title: '乡镇基层会议',
    pcUrl: IMG_PRE + 'scene-img1.jpg',
  },
  {
    title: '末端机构远程协同',
    pcUrl: IMG_PRE + 'scene-img2.jpg',
  },
  {
    title: '医院科室远程会诊研讨',
    pcUrl: IMG_PRE + 'scene-img3.jpg',
  },
];
const Index = () => {
  return (
    <Wrapper title="中小型终端" menuIndex="2" current={4} customClass={style.ge300}>
      <MultipleBanner
        mUrl={`${IMG_PRE}m/bg0.jpg`}
        className={cn(style.banner, style.firstBanner)}
        type={4}
        pcUrl={`${IMG_PRE}bg0.jpg`}
        title={'中小型会议室\n一体式终端'}
        animate={'fadeIn'}
        delay={0.5}
        desc={'一键开启高清会议，支持内容共享、批注与白板显示\n异地协作轻松高效'}
      />
      <Medias
        title={'一体化设计，极速部署'}
        desc={'集主机、摄像机、麦克风、Wi-Fi、蓝牙等多个模块于一体\n极简安装部署，可快速搭建视频会议环境'}
        features={features}
        imgPre={IMG_PRE}
        bgImage={'bg1.jpg'}
        bgImageM={'m/bg1.jpg'}
        type={1}
      />
      <MultipleBanner
        mUrl={`${IMG_PRE}m/bg2.jpg`}
        className={cn(style.banner, style.banner1)}
        type={4}
        pcUrl={`${IMG_PRE}bg2.jpg`}
        title={'双屏双显，高清逼真'}
        animate={'fadeIn'}
        delay={0.5}
        desc={'支持画面双屏双显功能，内容共享、演讲两不误\n高清画面效果，远程场景逼真立现'}
      />
      <Scheme animate="fadeIn" delay={0.5} data={AI} title={'AI功能，创意无限'} className={cn(style.ai)} />
      {bannerList.map((item: any) => {
        return <MultipleBanner {...item} animate={'fadeIn'} delay={0.5} descCenter key={item.title} imageHost={IMG_PRE} className={cn(style.banner, item.className)} />;
      })}
      <Scheme animate="fadeIn" delay={0.5} data={scene} title={'应用场景'} className={style.scene} />
      <Contact className={style.contact} btnType={'newBtn'} />
    </Wrapper>
  );
};

export default Index;
